import * as React from 'react';
import {connect} from 'react-redux';
import Switch from "react-switch";
import Select from 'react-select';
import {AttributeTypeEnum} from "../enums/AttributeTypeEnum";
import * as toastr from 'toastr'

import Modal from "react-responsive-modal";
import AsyncPaginate from "react-select-async-paginate";
import Utils from "../../../Utils";

interface Props {
    onRef?: any;
    businessObjectsWrapper: any;

    onSet(config: any): void;
}

interface State {
    isOpen: boolean;
    createRelationships: boolean;

    currentBoClassId: number | null;

    relationships: any[];
    defaultAttribute: { label: string, type: string, value: number, bocId: string } | null;
    defaultRelationship: { label: string, value: number } | null;
    attributes: { label: string; options: { label: string, value: number }[] }[];
}

class LookUpConfigModal extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            isOpen: false,
            createRelationships: false,

            currentBoClassId: null,
            defaultAttribute: null,
            defaultRelationship: null,
            relationships: null,
            attributes: Array.from(props.businessObjectsWrapper.dictionary.values()).map((businessObject: any) => {
                return {
                    label: businessObject.name,
                    optgroup: true,
                    options: Array.from(businessObject.attributes.values()).filter((attribute: any) => attribute.type !== AttributeTypeEnum.VALUE_LIST).map((attribute: any) => {
                        return {
                            label: attribute.name,
                            type: attribute.type,
                            value: attribute.id,
                            bocId: businessObject.id
                        }
                    })
                }
            })
        };
    }

    componentDidMount(): void {
        if (this.props.onRef) {
            this.props.onRef(this);
        }
    }

    open = (lookupAttributeId: number, lookupRelTypeId: number, createRelationships, currentBoClassId: number) => {
        const defaultAttribute = this.state.attributes.reduce((result: any, {options}) => {
            if (options && !result) {
                result = options.find(option => option.value === lookupAttributeId);
            }
            return result;
        }, null);
        const relationships = defaultAttribute ? this.getRelationships(currentBoClassId, defaultAttribute.bocId) : [];
        const defaultRelationship = relationships.reduce((result: any, {options}) => {
            if (options && !result) {
                result = options.find(option => option.value === lookupRelTypeId);
            }
            return result;
        }, null);
        this.setState({
            isOpen: true,
            defaultAttribute,
            defaultRelationship,
            relationships,
            createRelationships,
            currentBoClassId
        });
    };

    getRelationships = (currentBoClassId: number, attributeBocId: number): any[] => {
        const relSet: Set<number> = new Set();
        return Array.from(this.props.businessObjectsWrapper.dictionary.values()).map((businessObject: any) => {
            return {
                label: businessObject.name,
                options: Array.from(businessObject.relationships.values())
                    .filter((relationship: any) => {
                            if (currentBoClassId) {
                                if ((relationship.fromBoClass.id === attributeBocId && relationship.toBoClass.id === currentBoClassId) || (relationship.fromBoClass.id === currentBoClassId && relationship.toBoClass.id === attributeBocId)) {
                                    if (!relSet.has(relationship.id)) {
                                        relSet.add(relationship.id);
                                        return true;
                                    }
                                }
                                return false;
                            }
                            if (!relSet.has(relationship.id)) {
                                relSet.add(relationship.id);
                                return true
                            }
                            return false;
                        }
                    )
                    .map((relationship: any) => {
                        return {label: relationship.name, value: relationship.id}
                    })
            }
        });

    };

    close = () => {
        this.setState({
            isOpen: false,
            defaultAttribute: null,
            defaultRelationship: null,
            createRelationships: false
        });
    };

    onAttributeValueChange = (value: any) => {
        const relationships = this.getRelationships(this.state.currentBoClassId, value.bocId);
        this.setState({
            defaultAttribute: {label: value.label, type: value.type, value: value.value, bocId: value.bocId},
            relationships,
            defaultRelationship: this.state.defaultAttribute && this.state.defaultAttribute.bocId !== value.bocId ? null : this.state.defaultRelationship,
            createRelationships: this.state.defaultAttribute && this.state.defaultAttribute.bocId !== value.bocId ? false : this.state.createRelationships
        });
    };

    onRelationshipValueChange = (value: any) => {
        this.setState({defaultRelationship: {label: value.label, value: value.value}});
    };

    onSet = () => {
        if (this.state.defaultAttribute) {
            if (this.state.createRelationships) {
                if (this.state.defaultRelationship) {
                    this.props.onSet({
                        defaultAttribute: this.state.defaultAttribute,
                        defaultRelationship: this.state.defaultRelationship,
                        createRelationships: this.state.createRelationships
                    });
                } else {
                    toastr.warning("Please select relationship");
                }
            } else {
                this.props.onSet({
                    defaultAttribute: this.state.defaultAttribute,
                    defaultRelationship: this.state.defaultRelationship,
                    createRelationships: this.state.createRelationships
                });
            }
        } else {
            toastr.warning("Please select attribute");
        }
    };

    onCreateRelationshipsChange = () => {
        this.setState({createRelationships: !this.state.createRelationships});
    };

    // optionRenderer = (value: any) => {
    //     if (value.optgroup) {
    //         return <label>{value.label}</label>
    //     } else {
    //         return (
    //             <div style={{width: "100%", height: 18}}>
    //                 <span style={{float: "left"}}>{value.label}</span>
    //                 <span style={{
    //                     float: "right",
    //                     color: "rgb(93, 200, 232)",
    //                     fontWeight: "bold"
    //                 }}>{value.type}</span>
    //             </div>
    //         )
    //     }
    // };

    // valueRenderer = (value: any) => {
    //     return (
    //         <div style={{width: "100%"}}>
    //             <span style={{float: "left"}}>{value.label}</span>
    //             <span style={{
    //                 float: "right",
    //                 color: "rgb(93, 200, 232)",
    //                 fontWeight: "bold",
    //                 marginRight: 35
    //             }}>{value.type}</span>
    //         </div>
    //     )
    // };

    render() {
        return (
            <Modal
                open={this.state.isOpen}
                styles={{
                    overlay: {zIndex: 10000},
                    closeButton: {display: "none"},
                    modal: {
                        width: 400,
                        padding: 0,
                        maxWidth: 400,
                    }
                }}
                closeOnEsc={true}
                onClose={this.close}
                center
                focusTrapped={true}
                closeOnOverlayClick={false}
            >
                <div style={{width: '100%', height: '85%', backgroundColor: "#2B2B2B"}}>
                    <div className="row" style={{height: '100%'}}>
                        <div className='col-lg-12 compare-changes'>
                            <header>
                                <h2 style={{
                                    margin: 0,
                                    background: '#2D3436',
                                    borderBottom: '2px solid #f5f5f5a3',
                                    width: '100%',
                                    textAlign: 'center',
                                    fontSize: 20,
                                    padding: '10px 5px 5px 5px',
                                    fontWeight: 600,
                                    color: '#f5f5f5a3',
                                    height: 45,
                                }}>LookUp Configuration</h2>
                            </header>
                            <div style={{
                                minHeight: 185,
                                height: "auto",
                                display: 'flex',
                                maxHeight: 800,
                                overflow: 'auto',
                            }}>
                                <div style={{width: '90%', margin: "auto"}}>
                                    <div style={{marginBottom: 5}}>
                                        <div>
                                            <label style={{color: "white", fontSize: 14,}}>Attribute</label>
                                        </div>
                                        <div>
                                            <Select
                                                value={this.state.defaultAttribute}
                                                onChange={this.onAttributeValueChange.bind(this)}
                                                options={this.state.attributes}
                                                clearable={false}
                                                styles={Utils.getReactSelectNewDesign(true)}
                                                theme={theme => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#4e767a',
                                                        primary: '#3D6367',
                                                        primary50: '#4e767a'
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>
                                    <div style={{display: "flex", justifyContent: "space-between", paddingTop: 5, paddingBottom: 5}}>
                                        <div>
                                            <label style={{color: "white", fontSize: 14, marginTop: 4}}>Create Relationships</label>
                                        </div>
                                        <div>
                                            <div style={{float: "right"}}>
                                                <Switch
                                                    key={this.state.createRelationships === true ? "true" : "false"}
                                                    checked={this.state.createRelationships}
                                                    onChange={this.onCreateRelationshipsChange.bind(this)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.createRelationships ?
                                        <div style={{marginBottom: 5}}>
                                            <div>
                                                <Select
                                                    required={true}
                                                    name={"lookup-relationships"}
                                                    noResultsText={"No Relationships Found"}
                                                    value={this.state.defaultRelationship}
                                                    onChange={this.onRelationshipValueChange.bind(this)}
                                                    options={this.state.relationships}
                                                    styles={Utils.getReactSelectNewDesign(true)}
                                                    theme={theme => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#4e767a',
                                                            primary: '#3D6367',
                                                            primary50: '#4e767a'
                                                        },
                                                    })}
                                                />
                                            </div>
                                        </div>
                                        : null}
                                </div>
                            </div>
                            <footer style={{
                                background: "#2D3436",
                                borderTop: "2px solid #f5f5f5a3",
                                height: 49,
                                width: "100%",
                                paddingRight: 5,
                                paddingTop: 3,
                            }}>
                                <button
                                    onClick={this.onSet}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginLeft: 4}}>
                                    <i className="fas fa-check"> Set</i>
                                </button>
                                <button
                                    onClick={this.close}
                                    className={"btn"}
                                    style={{float: "right", marginTop: 3, marginRight: 2}}>
                                    <i className="fas fa-times"> Close</i>
                                </button>
                            </footer>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        onSet: ownProps.onSet,
        businessObjectsWrapper: state.boCore.businessObjectsWrapper
    }
};

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(LookUpConfigModal)



// WEBPACK FOOTER //
// ./app/components/bo-core/modals/LookUpConfigModal.tsx